import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

// eslint-disable-next-line import/no-extraneous-dependencies
import qs from 'qs';

import SignAdjustedPositionsContainer from '../../containers/sign-adjusted-positions-container';
import SignOrderProcessOrderContainer from '../../containers/sign-process-order-container';
import AppPageMain from '../../modules/app-page/app-page--main';
import PageHeader from '../../modules/page-header';

const SignProcessPage: React.FC = () => {
  const location = useLocation();
  const params = qs.parse(location.search);
  const { id } = useParams<{ id: string }>();

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                { link: '/orders', title: 'Реестр' },
                {
                  link: `/orders/${id}`,
                  title: `Поставка ${id}`,
                },
              ]}
              iconType="order"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            {params['?type'] === 'adjustment' ? (
              <SignAdjustedPositionsContainer />
            ) : (
              <SignOrderProcessOrderContainer />
            )}
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default SignProcessPage;
